import React from "react";
import medical from "../assets/drali.png";

const MedicalArtical = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 mb-4">  
        {"Breathing Problems Are Ruining Your Life… Stealing Joy, Sleep & Freedom!"}
      </h1>  
      <div className="mb-4">  
        <img   
          src={medical} 
          alt="Doctor examining lung x-ray"
          className="w-full rounded-3xl border border-gray-100"  
          draggable="false"   
        /> 
        <div className="bg-[#fff3c4] border border-[#fdcc5e] mt-3 p-2 text-[#303030] italic text-lg"> 
          {"Dr. Ali and his team of lung specialists, combining a decade of research."} 
        </div>
      </div> 
      <div className="space-y-4 text-[#303030]"> 
        <p> 
          {"Dr. Ali and his team spent several years searching for a solution to effectively clear the lungs and relieve breathing problems with an all-natural alternative for people struggling with respiratory issues. Today, that search has finally yielded results—thanks to this plant-based extract, designed to target lung health at its core."}
        </p>  
        <p>  
          {"But it wasn’t until earlier this year that they truly unraveled the code that could blow up modern medicine, cleanse your lungs, and give you healthy, free breathing back forever. It all started with a personal breakthrough discovery Dr. Ali had earlier this year."}
        </p>  
        <p>   
          {"One evening, as he was reviewing clinical studies on the causes of respiratory diseases, he came across something that shocked him."}
        </p>  
      </div>  
    </div> 
  ); 
};  

export default MedicalArtical;
